<template>
  <div class="value">
    <div
      v-for="list in values"
      :key="list.id"
      class="value_list"
    >
      <div class="round">
        <img
          :src="list.src"
          alt=""
        >
      </div>
      <div class="title">
        {{ list.title }}
      </div>
      <div class="value_content">
        {{ list.content }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String },
    content: { type: String },
    src: { type: String },
    values: { type: Array }
  },
  data() {
    return {}
  }
}
</script>

<style lang="less" scoped>
.value {
  width: 70%;
  margin: 0 auto;
  display: flex;
  margin-bottom: 100px;

  .value_list {
    width: 24%;
    margin-top: 30px;
    margin: 0 1%;
    background: rgba(237, 242, 253, 1);
    border-radius: 30px;
    padding: 3% 2%;
    height: 700px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .round {
      width: 110px;
      height: 110px;
      border-radius: 100%;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    img {
      width: 100px;
      height: 100px;

    }

    .title {
      font-size: 24px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      text-align: center;
      margin: 17px 25px 26px;
      height: 64px;

    }

    .value_content {
      font-size: 20px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      margin: 0 20px;
      line-height: 40px;
      text-align-last: center
    }
  }
}

@media screen and (min-width: 1200px) and (max-width: 1350px) {
  .value .value_list .value_content {
    font-size: 14px !important;
    line-height: 30px;
  }

  .value .value_list .title{
    font-size: 20px !important;
    margin: 20px 25px 20px !important;
  }
  .value{
    width: 85% !important;
  }
}

@media screen and (min-width: 1350px) and (max-width: 1500px) {
  .value .value_list .value_content {
    font-size: 16px !important;
    line-height: 35px;
  }

  .value .value_list .title {
    font-size: 22px !important;
    margin: 20px 25px 20px !important;
  }
  .value{
    width: 80% !important;
  }
}

@media screen and (min-width: 1500px) and (max-width: 1700px) {
  .value .value_list .value_content {
    font-size: 17px !important;
  }

  .value{
    width: 75% !important;
  }

}
</style>
